<template>
    <div class="FosterCaliforniaLayout" style="min-height:100vh" ref="content" v-if="UserPrivateProfile.UserId">

        <div style="touch-action:none;">
            <nav class="navbar navbar-light navbar-expand-md navigation-clean" style="z-index:2;">
                <a id="navbar-brand" class="navbar-brand pointer"><router-link to="/"><img v-bind:src="sitelogo" /></router-link></a>
            </nav>
        </div>
        <div>
            <b-row no-gutters>
                <b-col cols="2" class="sidebarColumn paper side-tabs" ref="sidebarColumn" style="max-width:max-content;white-space:nowrap;  height:fit-content;" v-if="!IsMobile">
                    <div class="sidebar" style="height: 100%; width:100%;  background-color:white;">
                        <!--WHEN SIDEBAR IS BIGGER-->
                        <div v-if="SidebarToggle == 'ON'">
                            <b-nav tabs vertical>
                                <div>
                                    <b-nav-item class="ExpandOrShrink" v-on:click="MaximizeSidebar()"><font-awesome-icon :icon="['fa', 'angle-double-left']" /> Minimize</b-nav-item>
                                    <b-nav-item v-on:click="ChangePaneShown('Course')" v-bind:class="{ active: PanesShown == 'Course' }"><font-awesome-icon :icon="['fa', 'chalkboard']" /> Courses</b-nav-item>
                                    <b-nav-item v-on:click="ChangePaneShown('Session')" v-bind:class="{ active: PanesShown == 'Session' }"><font-awesome-icon :icon="['fa', 'chalkboard-teacher']" /> Sessions</b-nav-item>
                                    <b-nav-item v-on:click="ChangePaneShown('Reports')" v-bind:class="{ active: PanesShown == 'Reports' }"><font-awesome-icon :icon="['fa', 'chart-bar']" /> Reports</b-nav-item>
                                </div>
                                <div>
                                    <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                                        <!--<b-card no-body>
                                            <b-nav-item v-if="CheckPermission('Navigation_AddChild')" v-on:click="ChangePaneShown('AddChild')" v-bind:class="{ active: PanesShown == 'AddChild' }"><font-awesome-icon :icon="['fa', 'plus']" /> Add Child</b-nav-item>
                                            <b-nav-item v-if="CheckPermission('Navigation_ChildList')" v-on:click="ChangePaneShown('Children')" v-bind:class="{ active: PanesShown == 'Children' }"><font-awesome-icon :icon="['fa', 'list']" /> List</b-nav-item>
                                            <b-nav-item v-for="(childRecord, childSPMID) in OpenChildRecords" v-if="childRecord.hasOwnProperty('Client')" v-bind:class="{ active: PanesShown == childSPMID }">
                                                <span v-on:click="ChangePaneShown(childSPMID)">
                                                    <font-awesome-icon :icon="['fa', 'child']" />
                                                    {{ childRecord.Client.Person.FirstNameLastInitial }}
                                                </span>
                                                <span style="float:right;" v-on:click="CloseChildRecord(childSPMID)">X</span>
                                            </b-nav-item>
                                        </b-card>-->
                                    </b-collapse>
                                </div>
                                <b-nav-item><Logout /></b-nav-item>
                            </b-nav>
                        </div>
                        <div>
                            <b-container v-if="SidebarToggle == 'OFF'" style="text-align:center; padding-left:20%;padding-right:20%;">
                                <div class="ExpandOrShrink"><font-awesome-icon :icon="['fa', 'angle-double-right']" class="ExpandButtons pointer" @click="MaximizeSidebar()" style="width:100%" /></div>
                                <div><font-awesome-icon class="pointer ExpandButtons" :icon="['fa', 'chalkboard']" style="width:80%" v-on:click="ChangePaneShown('Course')" /></div>
                                <div><font-awesome-icon class="pointer ExpandButtons" :icon="['fa', 'chalkboard-teacher']" style="width:80%" v-on:click="ChangePaneShown('Session')" /></div>
                                <div><font-awesome-icon class="pointer ExpandButtons" :icon="['fa', 'chart-bar']" style="width:80%" v-on:click="ChangePaneShown('Reports')" /></div>
                            </b-container>
                        </div>
                    </div>
                </b-col>
                <!--ON MOBILE-->
                <div v-if="IsMobile" style="display:block;width:100%;">
                    <Slideout menu="#menu" panel="#panel" ref="Slideout" />
                    <nav id="menu">
                        <div class="sidebar" style="height: 100%; width:100%;  background-color:white;">
                            <div style="height:64px; border-bottom-color:black;border-bottom-width:thin;border-bottom:double; justify-content:center;font-size:x-large;font-weight:bold;display:flex;align-items:center;">
                                <div> {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</div>
                            </div>
                            <b-nav tabs vertical>
                                <div>
                                    <b-nav-item @click="CloseSlideout()" v-on:click="ChangePaneShown('Course')" v-bind:class="{ active: PanesShown == 'Course' }"><font-awesome-icon :icon="['fas', 'cog']" /> Course</b-nav-item>
                                    <b-nav-item @click="CloseSlideout()" v-on:click="ChangePaneShown('Session')" v-bind:class="{ active: PanesShown == 'Session' }"><font-awesome-icon :icon="['fas', 'cog']" /> Session</b-nav-item>
                                    <b-nav-item @click="CloseSlideout()" v-on:click="ChangePaneShown('Reports')" v-bind:class="{ active: PanesShown == 'Reports' }"><font-awesome-icon :icon="['fas', 'chart-bar']" /> Reports</b-nav-item>
                                </div>

                    </nav>
                    <div id="panel">
                        <div>
                            <div v-show="PanesShown == 'Course'" class="paper" style="margin:0px !important;">
                                <Course />
                            </div>
                            <div v-show="PanesShown == 'Session'" class="paper" style="margin:0px !important;">
                                <Session />
                            </div>
                            <div v-show="PanesShown == 'Reports'" class="paper" style="margin:0px !important;">
                                <Reports />
                            </div>
                        </div>
                    </div>
                </div>
                <b-col v-if="!IsMobile" style="height:90vh;">
                    <div>
                        <div>
                            <div v-show="PanesShown == 'Course'" class="paper content">
                                <Course />
                            </div>
                            <div v-show="PanesShown == 'Session'" class="paper content">
                                <Session />
                            </div>
                            <div v-show="PanesShown == 'Reports'" class="paper content">
                                <Reports />
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <!--<SessionTimeout :timeout-seconds="1200" :warning-seconds="150" />-->
    </div>
    <!--Logged in User-->
    <!--<p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>-->

</template>

<script>
    //import services
    import { UserAPI } from '../../services/api/Core/UserAPI.js';
    import $ from 'jquery'
    import { isMobile } from 'mobile-device-detect';
    //import components
    import Course from './Course.vue';
    import Session from './Session.vue';
    import Reports from './Reports.vue';
    import Slideout from 'vue-slideout'

    import Logout from '../Core/UI/Logout.vue';
    //import UsersettingsPane from '../Usersettings/UsersettingsPane.vue';
    import SessionTimeout from '../Core/UI/SessionTimeout.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChalkboard } from '@fortawesome/free-solid-svg-icons';
    library.add(faChalkboard);
    import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
    library.add(faChalkboardTeacher);
    import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileAlt);
    import { faToolbox } from '@fortawesome/free-solid-svg-icons';
    library.add(faToolbox);
    import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faAngleDoubleLeft);
    import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faAngleDoubleRight);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faSignature } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignature);
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);

    import { EventBus } from '../../services/event-bus.js';
    export default {
        name: "TrainingLayout",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_FosterPortal.png",
                SidebarWidth: 0,
                DocumentsRequiringMySignature: 0,
                PanesShown: "Course",
                EmployeePrivateProfile: {
                    UserID: "",
                    EmployeeID: "",
                    Email: "",
                    FirstName: "",
                    LastName: "",
                    AssignedSubPrograms: [],
                    Permissions: [],
                    Roles: []
                },
                CoreProgramData: {
                    CoreProgramID: "",
                    CoreProgramName: "",
                    WarningAnnouncements: [],
                    Agencies: [],
                },
                SidebarToggle: "ON",
                ScreenWidth: ""
            };
        },
        methods: {
            CloseSlideout() {
                this.$refs.Slideout.slideout.toggle()
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            ChangePaneShown(paneName) {
                this.PanesShown = paneName;
            },
            GetEmployeePrivateProfile() {
                this.userAPI.GetEmployeePrivateProfile().then((data) => {
                    
                    //this.EmployeePrivateProfile = data.data;
                    this.$store.commit("User.PrivateProfile.Replace", data.data);
                });
            },
            CloseChildRecord: function (spmID) {
                if (this.PanesShown == spmID) {
                    this.ChangePaneShown("Children");
                }
                this.$store.commit("Clients.ClientProfiles.Remove", spmID);

            },
            MaximizeSidebar() {
                let vm = this;
                $('.ExpandOrShrink').unbind().click(function () {
                    if (vm.SidebarToggle == "OFF") {
                        $('.sidebarColumn').css({ "max-width": "max-content" });
                        vm.SidebarToggle = "ON";
                    }
                    else {
                        $('.sidebarColumn').stop().animate({ maxWidth: '7vh' });
                        vm.SidebarToggle = "OFF";
                    }

                });

            },
            ProfilePhotoURL(fileID) {
                console.log(fileID);
                if (fileID == null) {
                    return "/images/NoPhotoOnFile.jpg"
                } else {
                    return this.$baseURL + "/API/Core/Files/GetFileContent/profilephoto?FileID=" + fileID;
                }
            },
            CloseFamilyRecord: function (familyID) {
                if (this.PanesShown == familyID) {
                    this.ChangePaneShown("Families");
                }
                this.$store.commit("Families.FamilyProfiles.Remove", familyID);

            },
            DocumentsRequiringMySignatureComp: function () {
                if (this.DocumentsRequiringMySignature != 0) {
                    return this.DocumentsRequiringMySignature
                } else {
                    return "";
                }
            },
            OpenChildButton() {
                this.$refs["childDropdown"].show();
            },
            OpenCourseButton() {
                this.$refs["courseDropdown"].show();
            },
            OpenDocumentButton() {
                this.$refs["documentDropdown"].show();
            },
        },
        components: {
            Course,
            Logout,
            SessionTimeout,
            Session,
            Reports,
            Slideout
        },
        mounted() {
            this.GetEmployeePrivateProfile();
            if (this.IsMobile == true) {
                this.SidebarToggle = "OFF"
            }
            else {
                this.SidebarToggle = "ON"
            }
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            OpenChildRecords() {
                return this.$store.state.Clients.ClientProfiles;
            },
            OpenFamilyRecords() {
                return this.$store.state.Families.FamilyProfiles;
            },
            IsMobile: function () {
                return isMobile;
            },
        },
    }
</script>

<style scoped>
    /*.upper-right {
        position:absolute;
        top:0;
        right:40px;
    }*/
    .ExpandButtons {
        width: 100%;
        height: 100%;
        /*margin-top:1rem;*/
        color: black;
        padding-bottom: 1rem;
    }

    .content {
        position: absolute;
        width: 98%; /*stop page scroll*/
        min-height: 100%;
    }

    .sidebarSmallButtons > * {
        padding: 0;
        text-align: center;
    }
    /*li.active a {
        color: white;
    }*/
    .slideout-menu {
        position: fixed;
        top: 0;
        bottom: 0;
        width: 256px;
        height: 100vh;
        overflow-y: scroll;
        /*-webkit-overflow-scrolling: touch;*/
        z-index: 1;
        display: none;
        /*background-color: #1D1F20;
    color: white;*/
    }

    .slideout-menu-left {
        left: 0;
    }

    .slideout-menu-right {
        right: 0;
    }

    .slideout-panel {
        /*background-color: #4B5;
    color: white;*/
        touch-action: pan-y;
        position: relative;
        z-index: 1;
        will-change: transform;
    }

    .slideout-open,
    .slideout-open body,
    .slideout-open .slideout-panel {
        overflow: hidden;
    }

        .slideout-open .slideout-menu {
            display: block;
        }
</style>